<!-- Language selector -->
<div class="lang-select-wrap">
  <select
    class="lang-select eye-color eye-border eye-hover"
    [attr.aria-label]="'LANGUAGE_SELECT' | translate"
    [value]="languageService.currentLang"
    (change)="onLangSelected($event)"
  >
    @for (item of languageService.availableLangs; track item) {
      <option [value]="item" [selected]="item === languageService.currentLang">
        {{ (item === 'by' ? 'be' : item) | uppercase }}
      </option>
    }
  </select>
  <fa-icon
    class="lang-select-caret header-chevron"
    [icon]="faChevronDown"
    size="sm"
  ></fa-icon>
</div>
